import useRestoreScroll from '@hooks/useRestoreScroll';
import { cx } from 'class-variance-authority';
import * as React from 'react';

interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
    keepScrollPosition?: boolean;
    children: React.ReactNode;
    gutterStable?: boolean;
}

const ScrollArea: React.FC<ScrollAreaProps> = ({
    className,
    children,
    gutterStable = true,
    ...props
}: ScrollAreaProps) => {
    const scrollProps = useRestoreScroll<HTMLDivElement>('module_page_layout_accordion_scroll');

    return (
        <div className={cx('tw-relative tw-h-full tw-overflow-hidden', className)} {...props}>
            <div
                className={`tw-scrollbar-thumb-[#c4c4c4] tw-scrollbar-track-transparent tw-h-full tw-w-full tw-overflow-y-auto tw-overflow-x-hidden tw-pr-1`}
                style={{ scrollbarGutter: gutterStable ? 'stable' : 'auto', scrollbarWidth: 'thin' }}
                {...scrollProps}
            >
                {children}
            </div>
        </div>
    );
};

export default ScrollArea;
